import React from 'react'
import {
    Routes,
    Route,
} from "react-router-dom";
import AboutUs from "./about-us";
import DeleteAccount from "../delete-account";

class Home extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    UNSAFE_componentWillMount() {
    }

    render() {
        return(
            <Routes>
                <Route path="/request-delete-account" element={<DeleteAccount/>} />
            </Routes>
        )
    }
}

export default Home
